import {
  AlertSpg,
  BlockText,
  GridContainer,
  GridItem,
  isNotEmpty,
  selectThunkRecordById,
  ViewSection,
} from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useUserBirthPlace from "../../../../../../hooks/portal/view/user/useUserBirthPlace";
import { useEffect, useState } from "react";
import * as React from "react";
import { useTranslation } from "react-i18next";

const ReceiverAddressViewSection = ({ record }) => {
  const { t } = useTranslation();

  const [isEmptyReceiverAddress, setIsEmptyReceiverAddress] = useState(false);
  const countriesData = useAppSelector((state) => {
    return state.AppData.countriesData.data;
  });

  const { birthPlace } = useUserBirthPlace({
    country: record.receiverAddress?.country,
    settlement: record.receiverAddress?.settlement,
    city: record.receiverAddress?.city,
  });

  useEffect(() => {
    const receiverAddressValues = [
      record.receiverAddress?.name,
      record.receiverAddress?.country?.id,
      birthPlace,
      record.receiverAddress?.postCode,
      record.receiverAddress?.address,
      record.receiverAddress?.phone,
    ];

    const isEmpty =
      receiverAddressValues.filter(function (el) {
        return isNotEmpty(el);
      }).length === 0;
    setIsEmptyReceiverAddress(isEmpty);
    // eslint-disable-next-line
  }, []);

  return (
    <ViewSection label={"t.receiverAddress.details.default"}>
      {!isEmptyReceiverAddress && (
        <GridContainer spacing={3} mt={0}>
          <BlockText withGrid label={"l.address.name"} text={record.receiverAddress?.name} />
          <BlockText
            withGrid
            label={"l.address.country"}
            text={selectThunkRecordById(record.receiverAddress?.country?.id, countriesData)?.name}
          />
          <BlockText withGrid label={"l.address.cityName"} text={birthPlace} />
          <BlockText withGrid label={"l.address.postCode"} text={record.receiverAddress?.postCode} />
          <BlockText withGrid label={"l.address.address"} text={record.receiverAddress?.address} />
          <BlockText withGrid label={"l.address.phone"} text={record.receiverAddress?.phone} />
        </GridContainer>
      )}
      {isEmptyReceiverAddress && (
        <GridContainer spacing={2} mt={0}>
          <GridItem sm={12} md={12} lg={12} paddingLeft={"10px"}>
            <AlertSpg severity={"info"}>{t("m.empty.receiverAddress.default")}</AlertSpg>
          </GridItem>
        </GridContainer>
      )}
    </ViewSection>
  );
};
export default ReceiverAddressViewSection;
